import api from '@/api';

export type NotesLockStatus = {
  configured: boolean;
  notesLockSetAt?: number;
};

export type NotesLockConfig = NotesLockStatus & {
  notesLockSalt?: string;
  notesLockVerifier?: string;
};

export async function fetchNotesLockStatus(): Promise<NotesLockStatus> {
  const res = await api.get<{ status: string; lock?: NotesLockStatus }>('/notes/lock/status');
  return res.data.lock ?? { configured: false };
}

export async function fetchNotesLockConfig(): Promise<NotesLockConfig> {
  const res = await api.get<{ status: string; lock?: NotesLockConfig }>('/notes/lock/config');
  return res.data.lock ?? { configured: false };
}

export async function setupNotesLockPassword(body: {
  password: string;
  notesLockSalt: string;
  notesLockVerifier: string;
}): Promise<NotesLockStatus> {
  const res = await api.post<{ status: string; lock?: NotesLockStatus; message?: string }>(
    '/notes/lock/setup',
    body
  );
  if (res.data.status !== 'success') {
    throw new Error(res.data.message ?? 'Failed to set Notes lock password.');
  }
  return res.data.lock ?? { configured: true };
}

export async function changeNotesLockPassword(body: {
  notesLockSalt: string;
  notesLockVerifier: string;
}): Promise<NotesLockStatus> {
  const res = await api.post<{ status: string; lock?: NotesLockStatus; message?: string }>(
    '/notes/lock/change',
    body
  );
  if (res.data.status !== 'success') {
    throw new Error(res.data.message ?? 'Failed to change Notes lock password.');
  }
  return res.data.lock ?? { configured: true };
}

export async function resetNotesLockPassword(): Promise<void> {
  const res = await api.delete<{ status: string; message?: string }>('/notes/lock/reset');
  if (res.data.status !== 'success') {
    throw new Error(res.data.message ?? 'Failed to reset Notes lock password.');
  }
}
